import { ListSelection } from '../List';
export class DropdownSelection extends ListSelection {
    constructor() {
        super({ selectOnFocus: false });
    }
}
export class DropdownMultiSelection extends ListSelection {
    constructor() {
        super({ alwaysMerge: true, multiSelect: true, selectOnFocus: false });
    }
}
